import React from "react";
import PropTypes from "prop-types";

var UploadButton = function UploadButton(_ref) {
  var assetsUploader = _ref.assetsUploader;
  return React.createElement("label", {
    className: "recorder__tabs-button",
    style: {
      marginLeft: "auto",
      cursor: "pointer",
      lineHeight: "50px"
    }
  }, "+ upload", React.createElement("input", {
    type: "file",
    style: {
      display: "none"
    },
    accept: "image/*",
    onChange: function onChange(e) {
      return assetsUploader(e.target.files);
    }
  }));
};

UploadButton.propTypes = process.env.NODE_ENV !== "production" ? {
  assetsUploader: PropTypes.func.isRequired
} : {};
export default UploadButton;